import { render, staticRenderFns } from "./DeleteTemplateDialog.vue?vue&type=template&id=84cac93e&scoped=true"
import script from "./DeleteTemplateDialog.vue?vue&type=script&lang=js"
export * from "./DeleteTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cac93e",
  null
  
)

export default component.exports